import { render, staticRenderFns } from "./CheIdentificationFilter.vue?vue&type=template&id=6c22dc23&"
import script from "./CheIdentificationFilter.vue?vue&type=script&lang=ts&"
export * from "./CheIdentificationFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports